'use client';

import { Provider, atom } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';
import { useSearchParams } from 'next/navigation';
import { ReactNode } from 'react';

import { GlossaryPageGlossaryTermFragment } from './query.generated';

export const glossaryTermsAtom = atom<GlossaryPageGlossaryTermFragment[]>([]);
export const searchTextAtom = atom<string>('');
export const filteredGlossaryTermsAtom = atom((get) => {
  const glossaryTerms = get(glossaryTermsAtom);
  const searchText = get(searchTextAtom).toLowerCase();
  return glossaryTerms.filter(
    (x) => x.name?.toLowerCase().includes(searchText) || x.summary?.toLowerCase().includes(searchText),
  );
});

function GlossaryPageAtomsHydrator({
  glossaryTerms,
  searchText,
  children,
}: {
  glossaryTerms: GlossaryPageGlossaryTermFragment[];
  searchText: string;
  children: ReactNode;
}) {
  useHydrateAtoms([
    [glossaryTermsAtom, glossaryTerms],
    [searchTextAtom, searchText],
  ]);
  return children;
}

export const GlossaryPageJotaiProvider = ({
  children,
  glossaryTerms,
}: {
  children?: ReactNode;
  glossaryTerms: GlossaryPageGlossaryTermFragment[];
}) => {
  const searchParams = useSearchParams();
  const searchText = searchParams.get('search') ?? '';

  return (
    <Provider>
      <GlossaryPageAtomsHydrator glossaryTerms={glossaryTerms} searchText={searchText}>
        {children}
      </GlossaryPageAtomsHydrator>
    </Provider>
  );
};
